exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".touyide[data-v-53059a2c]{height:68px;margin-top:20px;display:flex}.touxiang[data-v-53059a2c]{width:68px;height:68px;border-radius:34px;margin-left:20px}.tongbu[data-v-53059a2c]{width:110px;height:30px;border:1px solid silver;border-radius:20px;margin-left:12px;margin-top:16px;display:flex;line-height:30px}.xuexijilu[data-v-53059a2c]{width:350px;height:100px;margin:0 auto;margin-top:20px;border-radius:4px;display:flex;border:1px solid silver}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-53059a2c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/menu/PersonalCenter/MyPage.vue
// module id = 564
// module chunks = 0